import { getTabloData } from '~/utils/api';
import TabloRequest from '~/requests/tablo';
import TabloList from '~/entities/tablo-list';

export default {
  async asyncData ({ store, route }) {
    const tablo = await getTabloData({ store, route, request: new TabloRequest(true) });
    return { tablo };
  },

  data () {
    return {
      tablo: {},
      tabloFormatted: {},
      tabloRequest: null,
      tabloLoading: false,
    };
  },

  created () {
    this.tabloRequest = new TabloRequest(this.route === 'tablo');
    this.transformTablo();
  },

  methods: {
    async refreshTablo({ day, direction }) {
      this.tabloLoading = true;
      this.tabloRequest.setDateByDay(day);
      this.tabloRequest.setDirection(direction);

      this.tablo = await getTabloData({
        store: this.$store,
        route: this.$route,
        request: this.tabloRequest,
      });

      this.transformTablo();

      this.tabloLoading = false;
    },
    transformTablo () {
      this.tabloFormatted  = new TabloList(this.tablo);
    },
  },
};
